import { Component, OnInit, Injector, ElementRef, ViewChild, AfterContentChecked } from '@angular/core';
import { WorkOrdersService } from '../../../work-orders.service';

@Component({
  selector: 'ga-comments-form',
  templateUrl: './ga-comments-form.component.html',
  styleUrls: ['./ga-comments-form.component.scss', '../../../work-orders.component.scss', '../../../../../ve/ve.component.scss']

})
export class GaCommentsFormComponent implements OnInit, AfterContentChecked {
  @ViewChild('printContainer', { static: true }) private readonly printContainerRef: ElementRef;
  printFormData = {
    RequestorComments: '',
    VEComments: '',
    WorkOrderComments: ''
  };
  workOrdersService: WorkOrdersService;

  constructor(injector: Injector) {
    this.workOrdersService = injector.get(WorkOrdersService);
  }

  ngOnInit() {
    //this is kept empty on purpose
  }

  ngAfterContentChecked() {
    this.setPrintData();
  }

  public setPrintData() {
    const requestorCommentsFormField = this.workOrdersService.workOrderDetailsForm.get('RequestorComments');
    const vECommentsFormField = this.workOrdersService.workOrderDetailsForm.get('VEComments');
    const workOrderCommentsFormField = this.workOrdersService.workOrderDetailsForm.get('WorkOrderComments');

    this.printFormData.RequestorComments = (requestorCommentsFormField && requestorCommentsFormField.value) ?
      requestorCommentsFormField.value : '';
    this.printFormData.VEComments = (vECommentsFormField && vECommentsFormField.value) ?
      vECommentsFormField.value : '';
    this.printFormData.WorkOrderComments = (workOrderCommentsFormField && workOrderCommentsFormField.value) ?
      workOrderCommentsFormField.value : '';
  }

  public getPrintElement(): ElementRef {
    this.setPrintData();
    return this.printContainerRef;
  }
}
